import React from 'react';
import "./FavouriteIcon.scss";
import ToolTipIcon from './ToolTipIcon';

export default function FavouriteIcon(props) {	
	const {active, onClick} = props;
	return (
		<ToolTipIcon icon="heart" title="Favourite" classPrefix="favourite" onClick={onClick} active={active}  />
	);
}